import preferencesUnit from './preferencesUnit.json';

const mutation = key => (state, value) =>
{
  state[key] = value;
};

const preferencesUnitSet = mutation('preferencesUnit');

export default
{
  state: () =>
  ({
    preferencesUnit,
  }),
  mutations:
  {
    preferencesUnitSet,
  },
};